/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-REACT-ICON
// DO NOT EDIT THIS FILE DIRECTLY, SEE README.md
import * as React from 'react';
import { useStyletron } from '../styles';
import { mergeOverride, toObjectOverride } from '../helpers/overrides';
import Icon from './icon';
import type { IconProps } from './types';

// @ts-ignore
function TrashCanFilled(props: IconProps, ref) {
  const [, theme] = useStyletron();
  const {
    title = 'Trash Can Filled',
    size,
    color,
    overrides = {},
    ...restProps
  } = props;
  const SvgOverride = mergeOverride(
  // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.TrashCanFilled ? theme.icons.TrashCanFilled : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return <Icon viewBox="0 0 24 24" ref={ref} title={title} size={size} color={color} overrides={{
    Svg: SvgOverride
  }} {...restProps}>
      <path fillRule="evenodd" clipRule="evenodd" d="M16 1v2h5v3H3V3h5V1h8ZM5 8h14v15H5V8Z" fill="currentColor" />
    </Icon>;
}
export default React.forwardRef<SVGSVGElement, IconProps>(TrashCanFilled);